import theme, {
    DRAWER_WIDTH, HEADER_HEIGHT
} from '../../services/theme'

const drawerBase = {
    paddingTop: HEADER_HEIGHT,
    width: DRAWER_WIDTH,
    backgroundColor: theme.palette.leftPanel.background
}

export default {
    body: {
        display: 'flex',
        minHeight: '100dvh',
        paddingLeft: 0,
        overflow: 'hidden',
        overflowY: 'hidden',
        backgroundColor: theme.palette.body.background
    },
    portalDrawer: {
        ['& .MuiDrawer-root']: {
            position: 'absolute'
        },
        ['& .MuiPaper-root']: {
            position: 'absolute'
        },
        [`& .MuiDrawer-paper`]: drawerBase
    },
    drawer: {
        [`& .MuiDrawer-paper`]: drawerBase
    },
    drawerDisplayed: {
        paddingLeft: DRAWER_WIDTH
    },
    portalMenuCta: {
        position: 'absolute',
        height: '40px',
        width: '40px',
        zIndex: `calc(${theme.zIndex.drawer} + 1)`,
        border: `1px solid ${theme.palette.border.subtle.main}`,
        backgroundColor: '#E4EBEE',
        boxShadows: 'unset',
        [`&:hover`]: {
            backgroundColor: theme.palette.leftPanel.hover,
            boxShadows: 'unset'
        },
        [`&.open`]: {
            left: `calc(${DRAWER_WIDTH} - 8px)`
        },
        [`&.close`]: {
            left: '5px'
        }
    }
}